import React from "react";
import '../../styles/components/tabbed-navigation/tabbed-navigation.scss';
import {NavLink, useMatch} from "react-router-dom";
import {appPagePaths} from "../../config/config";
import {FontIcon} from "../common/FontIcon";

export default function TabbedNavigation() {
  const matchesCoursesPage = useMatch(appPagePaths.coursesPage);
  const matchesCourseLessonsPages = useMatch('/course-lessons/:courseId([0-9]*)');
  const isCourses = matchesCoursesPage || matchesCourseLessonsPages;

  return (
    <div className="tabbed-navigation" role="navigation">
      <div><NavLink className={(navData) => navData.isActive ? `selected` : ''} to={appPagePaths.dashboardPage}><FontIcon icon={"icon-dashboard"}/><span>Dashboard</span></NavLink></div>
      <div><NavLink className={(navData) => navData.isActive ? `selected` : ''} to={appPagePaths.bootCampPage}><FontIcon icon={"icon-bootcamp"}/><span>Bootcamp</span></NavLink></div>
      <div>
        <NavLink
          className={(navData) => navData.isActive ? `selected` : ''}
          to={appPagePaths.songsPage}>
          <FontIcon icon={"icon-songs"}/>
          <span>Songs</span>
        </NavLink>
      </div>
      <div>
        {/* I think this is the v6 equivalent of what I had in v5, but I'll test later */}
        <NavLink className={(navData) => navData.isActive || isCourses ? `selected` : ''} to={appPagePaths.coursesPage}>
          <FontIcon icon={"icon-courses"}/>
          <span>Courses</span>
        </NavLink>
      </div>
      <div>
        <NavLink 
          className={(navData) => navData.isActive ? `selected` : ''}
          to={appPagePaths.settingsPage}>
          <FontIcon icon={"icon-settings"}/>
          <span>Settings</span>
        </NavLink>
      </div>
    </div>
  );

}
